<template>
    <footer>
        <div class="aboutus">
            <div><router-link to="/about" target="_blank">关于我们</router-link></div>
            <div><router-link to="/about/contact" target="_blank">联系我们</router-link></div>
            <div><router-link to="/about/statement" target="_blank">免责声明</router-link></div>
            <div><router-link to="/sitemap" target="_blank">网站地图</router-link></div>
        </div>
        <div class="copyright">
            版权所有©2024 玖寻导航 <a href="https://beian.miit.gov.cn" target="_blank">桂ICP备2024039627号-1</a>
        </div>
    </footer>
</template>

<script>
    export default {
        name: 'FooterBar',
    }
</script>
<style scoped>
/* 底部样式 */
footer {
    text-align: center;
    padding: 10px 0px;
    background-color: #e1e2e4;
    font-size: 12px;
    width: 1280px;
    margin: 0px auto;
}
.aboutus{
    margin-bottom: 5px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}
.aboutus div{
    margin-right: 20px;
}
.aboutus a{
    color: #404040;
}
.aboutus a:hover{
    color: #000000;
}
.copyright{
    color: gray;
}
.copyright a{
    color: gray;
}
.copyright a:hover{
    color: gray;
}
</style>